import { ROUTES } from '@shared/config/routes'
// Иконка нужна закомментированной карточке себестоимости.
// import costIcon from '../../assets/images/assistant/cost.svg'
import pairingIcon from '../../assets/images/assistant/pairing.svg'
import shapeIcon from '../../assets/images/assistant/shape.svg'

export interface AssistantService {
  id: string
  /** Заголовок карточки; в макете набран капслоком. */
  title: string
  description: string
  /** Иконка из макета; рисуется маской, поэтому цвет берётся от карточки. */
  icon: string
  /** Ширина при высоте `ICON_HEIGHT`: у иконок из макета разные пропорции. */
  iconWidth: number
  path: string
  /** Фон карточки: у каждого сервиса свой, чтобы отличать их с одного взгляда. */
  color: string
}

/**
 * Высота иконки внутри карточки, одинаковая у всех сервисов. В макете иконка
 * 158px на карточке 380px; на экране карточка вдвое меньше, поэтому и иконка
 * пересчитана в той же пропорции.
 */
export const ICON_HEIGHT = 70

/**
 * Сервисы хаба «Помощник». Раздел рассчитан на рост: новый инструмент — это
 * одна запись здесь, вёрстку править не нужно.
 *
 * Калькулятор пересчёта ингредиентов сюда не вынесен намеренно: он берёт
 * состав из открытой карточки и без неё показывает пустой экран, поэтому
 * живёт кнопкой внутри рецепта. «Перерасчёт формы» — его самостоятельный
 * вариант: размеры вводятся руками, карточка не нужна.
 *
 * Цвета — те, что макет показывает глазу: там фон задан с прозрачностью 0.7
 * поверх тёмного холста, а на белой странице те же значения дали бы выцветшие
 * карточки с нечитаемым белым текстом.
 */
export const ASSISTANT_SERVICES: readonly AssistantService[] = [
  {
    id: 'flavors',
    title: 'Фудпейринг',
    description: 'Находите удачные сочетания ингредиентов',
    icon: pairingIcon,
    iconWidth: 72,
    path: ROUTES.FLAVORS,
    color: '#5e8aa0',
  },
  // Калькулятор себестоимости скрыт из хаба. Сам экран остаётся рабочим и
  // доступен по прямой ссылке /cost-calculator — вернуть карточку значит
  // раскомментировать этот блок.
  // {
  //   id: 'cost-calculator',
  //   title: 'Калькулятор себестоимости',
  //   description: 'Рассчитывайте стоимость всего изделия и одной порции',
  //   icon: costIcon,
  //   iconWidth: 54.5,
  //   path: ROUTES.COST_CALCULATOR,
  //   color: '#a19cb3',
  // },
  {
    id: 'shape-calculator',
    title: 'Перерасчёт формы и размера',
    description: 'Адаптируйте рецепт под другую форму, размер и высоту',
    icon: shapeIcon,
    iconWidth: 69,
    path: ROUTES.SHAPE_CALCULATOR,
    color: '#554777',
  },
]
